<template>
    <div id="form-rating-scale">
        <div :class="`form-rating-scale rating-align-${localAlign}`">
            <input
                type="text"
                class="form-rating-scale-title"
                v-model="localFieldLabel"
                @blur="updateField"
                placeholder="Bir soru girin"
            />
            <div>
                <div class="scale">
                    <label v-for="n in 5" :key="n">
                        <input type="radio" :value="n" v-model="localRating" @change="updateField" />
                        <span>{{ n }}</span>
                    </label>
                </div>
                <div class="scale-labels">
                    <span>{{ localSubLabelOne }}</span>
                    <span>{{ localSubLabelTwo }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
    name: "form-rating-scale",
    props: {
        fieldLabel: String,
        align: String,
        subLabelOne: String,
        subLabelTwo: String,
        item: Object,
    },
    data() {
        return {
            localFieldLabel: this.fieldLabel || "",
            localAlign: this.align || "",
            localSubLabelOne: this.subLabelOne || "",
            localSubLabelTwo: this.subLabelTwo || "",
            localRating: null,
        };
    },
    methods: {
        ...mapActions("forms", ["updateFormField"]),
        updateField() {
            const updateFields = {
                label: this.localFieldLabel,
                ratingScale: {
                    fieldLabel: this.localFieldLabel,
                    rating: this.localRating,
                    subLabelOne: this.localSubLabelOne,
                    subLabelTwo: this.localSubLabelTwo,
                },
            };
            this.updateFormField({
                siteId: this.item.siteId,
                formFieldId: this.item._id,
                updateFields: updateFields,
            });
            this.$emit("update-field", updateFields);
        },
    },
    watch: {
        fieldLabel(newVal) {
            this.localFieldLabel = newVal;
        },
        align(newVal) {
            this.localAlign = newVal;
        },
        subLabelOne(newVal) {
            this.localSubLabelOne = newVal;
        },
        subLabelTwo(newVal) {
            this.localSubLabelTwo = newVal;
        },
    },
};
</script>

<style scoped lang="scss">
#form-rating-scale {
    .rating-align-left {
        flex-direction: initial !important;

        .form-rating-scale-title {
            width: auto !important;
            text-align: left;
            margin-right: 10px;
        }

        .scale {
            gap: 20px;
        }
    }

    .rating-align-right {
        flex-direction: initial !important;

        .form-rating-scale-title {
            width: auto !important;
            text-align: right;
            margin-right: 10px;
        }

        .scale {
            gap: 20px;
        }
    }

    .form-rating-scale {
        cursor: all-scroll;
        display: flex;
        flex-direction: column;
        margin: 20px 0;

        .form-rating-scale-title {
            display: block;
            font-size: 16px;
            font-weight: 600;
            margin-bottom: 8px;
            border: none;
            padding: 4px;
            width: 100%;
        }

        .scale {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 20px 0;

            label {
                display: flex;
                flex-direction: column;
                align-items: center;

                input[type="radio"] {
                    display: none;
                }

                span {
                    display: inline-block;
                    width: 40px;
                    height: 40px;
                    border: 2px solid #ccc;
                    border-radius: 50%;
                    text-align: center;
                    line-height: 36px;
                    font-size: 1.2em;
                    cursor: pointer;
                    transition: border-color 0.3s ease;
                }

                input[type="radio"]:checked + span {
                    border-color: #007bff;
                }
            }
        }

        .scale-labels {
            display: flex;
            justify-content: space-between;

            span {
                font-size: 1em;
                color: #666;
            }
        }
    }
}
</style>
